// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Jcmz","content":"styles_content__OCudE"};